var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getEhashCookie, getEhashFromPartAuthData, getSupporterID, normalizeObject, dataLayerPush, } from "./utils";
/**
 * Converts specific event data to a data layer object and pushes it to the data layer.
 *
 * @param specificEventData - The specific event data to be converted.
 */
var dataToDataLayer = function (specificEventData) {
    var dlData = normalizeObject(__assign({ ehash: getEhash(), event_category: "sponsor_nurture_cta", msc_card_position: "pos0", msc_card_type: "sponsor_nurture_cta", supporter_id: getSupporterID() }, specificEventData));
    dataLayerPush(dlData);
};
/**
 * Retrieves the ehash value from the SESSehash cookie or generates it from the SESSpartauth cookie.
 *
 * @returns The ehash value.
 */
var getEhash = function () {
    var ehashCookie = getEhashCookie();
    if (ehashCookie) {
        return ehashCookie;
    }
    return getEhashFromPartAuthData();
};
/**
 * Pushes a dataLayer event indicating an in-viewport view of the Sponsor Nurture CTA custom Gutenberg block.
 *
 * @param {CustomEvent} e - The custom event object.
 * @property {string} e.detail.block_title - The metadata title of the block (or page name).
 * @property {string} e.detail.child_id - The ID of the child.
 * @property {string} e.detail.community_name - The name of the community.
 * @property {string} e.detail.country_name - The name of the country.
 * @returns {void}
 */
var sponNurtureCtaBlockView = function (e) {
    dataToDataLayer({
        event: "feed_card_view",
        event_action: "msc_feed_card_impression",
        event_label: e === null || e === void 0 ? void 0 : e.detail["block_title"],
        msc_card_title: e === null || e === void 0 ? void 0 : e.detail["block_title"],
        msc_child_id: e === null || e === void 0 ? void 0 : e.detail["child_id"],
        msc_community_name: e === null || e === void 0 ? void 0 : e.detail["community_name"],
        msc_country_name: e === null || e === void 0 ? void 0 : e.detail["country_name"],
        non_interaction: true
    });
};
/**
 * Pushes a dataLayer event indicating a button click on the Sponsor Nurture CTA custom Gutenberg block.
 *
 * @param {CustomEvent} e - The custom event object.
 * @param {string} e.detail.block_title - The metadata title of the block (or page name).
 * @param {string} e.detail.button_text - The text of the button.
 * @param {string} e.detail.child_id - The ID of the child.
 * @param {string} e.detail.community_name - The name of the community.
 * @param {string} e.detail.country_name - The name of the country.
 */
var sponNurtureCtaBlockClick = function (e) {
    dataToDataLayer({
        event: "feed_card_click",
        event_action: "msc_feed_card_click",
        event_label: "".concat(e === null || e === void 0 ? void 0 : e.detail["block_title"], ":").concat(e === null || e === void 0 ? void 0 : e.detail["button_text"]),
        msc_card_title: e === null || e === void 0 ? void 0 : e.detail["block_title"],
        msc_child_id: e === null || e === void 0 ? void 0 : e.detail["child_id"],
        msc_community_name: e === null || e === void 0 ? void 0 : e.detail["community_name"],
        msc_country_name: e === null || e === void 0 ? void 0 : e.detail["country_name"],
        ret_my_sponsored_child_interactions: 1,
        retain_interactions: 1
    });
};
export { sponNurtureCtaBlockView, sponNurtureCtaBlockClick };
